import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ImportTsdPayload {
  customerId: string;
  templateId: string;
  declarantId: string;
  userId: string;
  resetCustomsData: boolean;
  file: File;
}

export const useAdminImportTsd = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ImportTsdPayload) => {
      const formData = new FormData();

      formData.append('file', payload.file);
      formData.append('customerId', payload.customerId);
      formData.append('templateId', payload.templateId);
      formData.append('declarantId', payload.declarantId);
      formData.append('userId', payload.userId);
      formData.append('resetCustomsData', `${payload.resetCustomsData}`);

      await request({
        path: 'admin/import-tsd',
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['admin-temporary-storages'] });
    },
    onError: (error) => {
      showErrorToast(error, 'Failed to import TSD');
    },
  });
};
